module.exports = "/_next/static/images/group-1610f95eef9822c4c1230c1a4e2673a2.png";